import { Module } from "wrapper6";
import { CountUp } from "countup.js";

var $ = jQuery;

export default class NumbersLine extends Module {

  ready(app) {

    this.numbersSectionsValues = document.querySelectorAll('.mtt-numbers-line .value')

    if (this.numbersSectionsValues.length) {
      for (let i = 0; i < this.numbersSectionsValues.length; i++) {
        const element = this.numbersSectionsValues[i];
        let hasRun = false;

        if (this.isElementInViewport(element)){
          this.addCountUp(element)
          hasRun = true;
        }
        
        document.addEventListener('scroll', () => {
          if (this.isElementInViewport(element) && !hasRun){
            this.addCountUp(element)
            hasRun = true;
          }
        })
      }
    }
  }

  addCountUp(element) {
    if (element) {
      const value = element.innerHTML;
      let hasDecimal = false;
      
      if (value.indexOf('.') !== -1){
        hasDecimal = true;
      }
      
      const options = {
        decimalPlaces: hasDecimal ? 1 : '',
        separator: !element.classList.contains('no-dot') ? '.' : '',
        decimal: ',',
      };
      
      let counter = new CountUp(element, value, options);
      
      if (!counter.error) {
        counter.start();
      }
    }
  }

  isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
  
    return rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */ &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */;
  }
}